module.exports = __webpack_public_path__ + "static/media/CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu.e8ce84f7.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL115_1Aqx-YUD-_rxM3AzXoiGrX3t3YFALDiVu
// module id = 769
// module chunks = 0